import styled from 'styled-components';
import device from '../../../GlobalDigitalStyle/BreakPoint.style';

export const InputContainer: any = styled.div`
	font-family: 'Manrope', sans-serif !important ;
	display: flex;
	min-height: 6em;
	flex-direction: column;
	/* min-width: calc(${(props: any) => props.width}% - 1.25rem); */
	width: 100%;
	/* flex-grow: ${(props: any) => `${props.width}`};
  flex-shrink: ${(props: any) => `${props.width / 4}`}; */
	position: relative;
	.form-control-lg {
		/* min-height: 3.2em; */
		font-size: 1em;
		font-family: 'Manrope';
		font-weight: 600;
	}
	input {
		@media (max-width: 1550px) {
			/* height: 3.1em; */
			font-size: 1em;
		}
		@media ${device.screen1280} {
			/* min-height: 3em !important;
			height: 3em !important; */
			font-size: 0.9em;
		}
	}

	/* @media (max-width: 1024px) {
		min-width: 100%;
	} */
	button.eye {
		position: absolute;
		right: 0.5125em;
		top: 3.4625em;
		width: 1.875em;
		height: 1.875em;
		padding: 0;
		cursor: pointer;
		border: 0;
		background-color: #0000;
		@media ${device.screen1280} {
			top: 3.3625em;
		}
	}
	button.eye.hide {
		::after {
			content: ' ';
			position: absolute;
			z-index: 1;
			top: 13px;
			right: 0px;
			width: 30px;
			height: 2px;
			background-color: gray;
			color: gray;
			transform: rotate(120deg);
			@media ${device.screen1280} {
				top: 10px;
				right: 0px;
				width: 21px;
				height: 2px;
			}
		}
	}
	.lable {
		font-family: 'Manrope', sans-serif !important ;
		font-size: 1.125em;
		color: #1e1e1e;
		margin-bottom: 1em;
		line-height: normal;
		font-weight: 700;
	}
`;
